interface VibrantSectionHeaderProps {
  badge: string;
  title: string;
  description?: string;
  badgeColor?: "green" | "blue" | "gold" | "purple" | "default";
}

const badgeColors = {
  green: "bg-gradient-to-r from-eco-green/20 to-teal-bright/20 text-eco-green border-eco-green/30",
  blue: "bg-gradient-to-r from-sky-blue/20 to-purple/20 text-sky-blue border-sky-blue/30",
  gold: "bg-gradient-to-r from-primary/20 to-amber-glow/20 text-primary border-primary/30",
  purple: "bg-gradient-to-r from-purple/20 to-rose/20 text-purple border-purple/30",
  default: "bg-primary/20 text-primary border-primary/30",
};

const VibrantSectionHeader = ({ 
  badge, 
  title, 
  description, 
  badgeColor = "default" 
}: VibrantSectionHeaderProps) => {
  return (
    <div className="text-center mb-12">
      <span className={`inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4 border ${badgeColors[badgeColor]} animate-pulse-glow`}>
        {badge}
      </span>
      <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
        {title}
      </h2>
      {description && (
        <p className="text-muted-foreground max-w-2xl mx-auto">
          {description}
        </p>
      )}
    </div>
  );
};

export default VibrantSectionHeader;
